import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

interface AnalysisFeedbackSuccessScreenProps {
  onCancel: () => void;
}

export const AnalysisFeedbackSuccessScreen = ({ onCancel }: AnalysisFeedbackSuccessScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onCancel}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'aiInsights.feedback.thanks',
          defaultMessage: 'Thanks for your feedback.'
        })}
      />
    </WizardScreen>
  );
};
